import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../../constants/common'
import { useNotification } from '../../../hooks'
import { MultiValuedListMoreItems } from '../../MultiValuedList'

function EntityAsyncMultiValuedListMoreItems({
  getData,
  getDataItems,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleAddNotification } = useNotification()

  const [items, setItems] = useState(EMPTY_LIST)

  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    getData()
      .then(response => {
        setItems(getDataItems(response))
      })
      .catch(() => {
        handleAddNotification({
          title: t('Error.CommonApiRequestFailKey'),
          type: NOTIFICATION_TYPE.error,
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <MultiValuedListMoreItems
      {...restProps}
      isLoading={isLoading}
      items={items}
    />
  )
}

export default EntityAsyncMultiValuedListMoreItems
